import React from "react";

const LookUpsList = ({ lookups, selected, setSelected }) => {
  return (
    <>
      <ul className="lookupsList">
        {lookups &&
          lookups.map((lookup) => (
            <li
              key={lookup.id}
              className={selected.id === lookup.id ? "active" : ""}
              onClick={() => setSelected(lookup)}
            >
              <h4>
                {lookup.value.split("-")[0]}{" "}
                {lookup.value.split("-")[1] && (
                  <span className="label">{lookup.value.split("-")[1]}</span>
                )}
              </h4>
            </li>
          ))}
        {/* <li>
                    <h4>Structure  <span className='label'>Frame</span></h4>
                </li>
                <li>
                    <h4>Structure  <span className='label'>Frame</span></h4>
                </li>
                <li>
                    <h4>Structure  <span className='label'>Frame</span></h4>
                </li>
                <li>
                    <h4>Structure  <span className='label'>Frame</span></h4>
                </li>
                <li>
                    <h4>Structure  <span className='label'>Frame</span></h4>
                </li>
                <li>
                    <h4>Structure  <span className='label'>Frame</span></h4>
                </li>
                <li>
                    <h4>Structure  <span className='label'>Frame</span></h4>
                </li> */}
      </ul>
    </>
  );
};

export default LookUpsList;
